import React from 'react'
import { cx } from 'utils/cx'

import { ButtonBase } from '../ButtonBase'

import styles from './FloatingButton.module.scss'

interface FloatingButtonProps extends React.ComponentProps<'button'> {
	readonly fullWidth?: boolean
	readonly icon?: React.ReactNode
	readonly centeredText?: boolean
}

export function FloatingButton(props: FloatingButtonProps): React.ReactNode {
	const { className, children, icon, fullWidth, centeredText, ...rest } = props

	const isIconOnly: boolean = !children && !!icon
	const isTextOnly: boolean = !!children && !icon

	return (
		<ButtonBase
			{...rest}
			className={cx(
				className,
				styles.floatingButton,
				isIconOnly && styles.iconOnly,
				isTextOnly && styles.textOnly,
				centeredText && styles.centeredText
			)}
		>
			{children && <span className={styles.content}>{children}</span>}
			{icon && <span className={styles.icon}>{icon}</span>}
		</ButtonBase>
	)
}
